export const StatusWarningRedIcon = (props) => (
  <svg
    style={{ ...props?.style }}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_1803_45)'>
      <path
        d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
        fill='#2DB0A9'
      />
      <path
        d='M15.2929 12.707C15.6834 12.3165 15.6834 11.6833 15.2929 11.2928L11.7071 7.70701C11.0771 7.07704 10 7.52321 10 8.41411V15.5857C10 16.4766 11.0771 16.9228 11.7071 16.2928L15.2929 12.707Z'
        fill='white'
      />
      <path
        d='M19.0513 13.5931C18.6714 12.9023 17.6788 12.9023 17.2989 13.5931L12.6652 22.0181C12.2986 22.6845 12.7808 23.5 13.5414 23.5H22.8088C23.5694 23.5 24.0516 22.6845 23.685 22.0181L19.0513 13.5931Z'
        fill='#EF4444'
      />
      <path
        d='M18.7501 16.4849C18.7501 16.2308 18.4927 16.0249 18.1751 16.0249C17.8575 16.0249 17.6001 16.2308 17.6001 16.4849V19.7677C17.6001 20.0218 17.8575 20.2277 18.1751 20.2277C18.4927 20.2277 18.7501 20.0218 18.7501 19.7677V16.4849Z'
        fill='white'
      />
      <path
        d='M18.7501 21.66C18.7501 21.3424 18.4927 21.085 18.1751 21.085C17.8575 21.085 17.6001 21.3424 17.6001 21.66C17.6001 21.9775 17.8575 22.235 18.1751 22.235C18.4927 22.235 18.7501 21.9775 18.7501 21.66Z'
        fill='white'
      />
    </g>
  </svg>
);
